import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  select(event) {
    const url = new URL(window.location.href);
    url.searchParams.set('challenge', event.target.value);
    window.location.href = url.href;
  }
}
